import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { Redirect, useHistory, useLocation } from "react-router-dom";

interface IVitecUsersContext {
    isLoading: boolean
    vitecUsers: IVitecUser[]
    recordCount: number
    search: ISearch

    doSearch: () => void
    handleChangePage: (event: any, page: number) => void
    deleteVitecUser: (id: string) => void
    updateSearch: (newSearch: ISearch) => void
}

export let vitecUsersContext = React.createContext({} as IVitecUsersContext);

let { Provider } = vitecUsersContext;

interface ISearch {
    searchText: string
    pageNr: number
    pageSize: number
}

interface IVitecUser {
    id: string
    email: string
    firstName: string
    lastName: string
    companyName: string
    countries: string[]
    isSuperAdmin: boolean
}

let VitecUserListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let history = useHistory();

    let [isLoading, setLoading] = useState(true);
    let [vitecUsers, setVitecUsers] = useState<IVitecUser[]>([]);
    let [recordCount, setTotalRecords] = useState(0);
    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20,
        searchText: '',
    });


    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            setSearch({
                ...search,
                ...state.search
            })
        }

        searchVitecUsers({
            ...search,
            ...state.search
        });
    }

    let doSearch = () => {
        let request = {
            ...search,
            pageNr: search.pageNr > 0 ? 0 : search.pageNr
        }

        history.push(location.pathname, { search: request });
    }

    let searchVitecUsers = async (values: ISearch) => {
        try {
            setLoading(true);
            let res = await axios.post('/api/User/SearchVitecUsers', search)
            setVitecUsers(res.data.items);
            setTotalRecords(res.data.recordCount);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch({
            ...newSearch
        });
    }

    let handleChangePage = (event: any, page: number) => {
        setSearch({
            ...search,
            pageNr: page
        });
    }

    let deleteVitecUser = async (id: string) => {
        if (window.confirm("Are you sure that you want to delete this user?")) {
            try {
                await axios.delete(`/api/User/DeleteVitecUser/${id}`);
                setVitecUsers(vitecUsers.filter(user => user.id !== id));
                setTotalRecords(recordCount - 1);
                enqueueSnackbar('User deleted', { variant: 'success' });
            } catch (err) { }
        }
    }


    return (
        <Provider value={{
            isLoading,
            vitecUsers,
            recordCount,
            search,

            doSearch,
            handleChangePage,
            deleteVitecUser,
            updateSearch
        }}>
            {children}
        </Provider>
    );
};

export default VitecUserListProvider;